(function () {
	'use strict';

	angular
		.module('customHeaders')
		.directive('hoverDropdown', ['$timeout', function ($timeout) {
			return {
				templateUrl: baseUrl + 'root/headers/hover-dropdown.tpl.html',
				replace: true,
				transclude: true,
				restrict: 'E',
				scope: {
					text: "@",
					identity: "@"
				},
				link: function (scope, elem, attrs) {
					scope.id = "nav-" + scope.identity;
					scope.contentId = "content-" + scope.identity;
					scope.hover = false;

					scope.handleHoverOver = function () {
						scope.hover = true;
					}

					scope.handleHoverOff = function () {
						scope.hover = false;
					}

					scope.handleEnterKey = function (e) {
						if (e.key === 'Enter') {
							this.handleHoverOver();
						}
					}

					scope.handleBlur = function (e) {
						$timeout(function () {
							var currentFocus = document.activeElement;
							if (elem && !elem[0].contains(currentFocus)) {
								scope.handleHoverOff();
							}
						})
					}
				}
			}
		}])
		.directive('focusout', ['$parse', function ($parse) {
			return {
				compile: function ($element, attr) {
					var fn = $parse(attr.focusout);
					return function handler(scope, element) {
						element.on('focusout', function (event) {
							scope.$apply(function () {
								fn(scope, { $event: event });
							});
						});
					};
				}
			};
		}]);
})();